import { relations, sql } from 'drizzle-orm'
import {
  bigint,
  index,
  jsonb,
  pgTable,
  text,
  uniqueIndex,
} from 'drizzle-orm/pg-core'
import {
  getBaseFields,
  getBaseIndexes,
  getIdReference,
  getTimestampWithTimezone,
} from '../common/utils'
import { users } from './user'

export const tasks = pgTable(
  'tasks',
  {
    ...getBaseFields(),
    title: text().notNull(),
    description: text(),
    deadline: getTimestampWithTimezone(),
    completedAt: getTimestampWithTimezone(),
    assignedUserId: getIdReference(() => users.id),
    createdByUserId: getIdReference(() => users.id),
    entityType: text(),
    entityId: bigint({ mode: 'number' }),
    deduplicationKey: text(),
    metadata: jsonb(),
  },
  (table) => [
    ...getBaseIndexes('tasks', table),
    index('tasks_entity_idx').on(table.entityType, table.entityId),
    uniqueIndex('tasks_deduplication_idx')
      .on(table.deduplicationKey)
      .where(sql`deleted_at IS NULL AND deduplication_key IS NOT NULL`),
  ],
)

export const tasksRelations = relations(tasks, ({ one }) => ({
  assignedUser: one(users, {
    fields: [tasks.assignedUserId],
    references: [users.id],
    relationName: 'assigned_tasks',
  }),
  createdBy: one(users, {
    fields: [tasks.createdByUserId],
    references: [users.id],
    relationName: 'created_tasks',
  }),
}))
